export const HOVER_EXTRA_COLS = 4;
export const HOVER_FLEX_GROW = 1 + HOVER_EXTRA_COLS;
export const EXPAND_DURATION_MS = 650;
export const HOVER_ENTER_DELAY_MS = 90;
export const HOVER_EXIT_DELAY_MS = 320;
export const SMOOTH_EASE = "cubic-bezier(0.4, 0, 0.2, 1)";
export const DOT_COLS = 4;
export const MOBILE_HOVER_DOT_COLS = 5;
export const DESKTOP_HOVER_DOT_COLS = 5;
export const DOT_SCATTER_X_PX = 80;
export const DOT_SCATTER_Y_PX = 120;
export const DOT_SCATTER_CLIP_PAD_PX = DOT_SCATTER_Y_PX + 16;
export const DOT_SCATTER_MIN_SCALE = 0.35;
export const DOT_SCATTER_MAX_SCALE = 1.65;
export const DOT_SCATTER_MIN_BLUR_PX = 4;
export const DOT_SCATTER_MAX_BLUR_PX = 14;
export const DOT_SCATTER_MIN_DURATION_S = 0.85;
export const DOT_SCATTER_MAX_DURATION_S = 1.45;
export const DOT_SCATTER_MAX_DELAY_S = 0.4;
export const DOT_PROXIMITY_MAGNETIC_WIDTH_RATIO = 0.48;
export const DOT_PROXIMITY_MAGNETIC_HEIGHT_RATIO = 0.14;
export const DOT_PROXIMITY_MAGNETIC_PULL = 2.5;
export const DOT_PROXIMITY_MAGNETIC_FALLOFF_POWER = 10;
export const DOT_PROXIMITY_MAX_SCALE = 2;
export const DOT_PROXIMITY_SCALE_WIDTH_RATIO = 0.5;
export const DOT_PROXIMITY_SCALE_HEIGHT_RATIO = 0.22;
export const DOT_PROXIMITY_SCALE_FALLOFF_POWER = 5;
export const DOT_PROXIMITY_ENABLE_BUFFER_MS = 80;
export const DOT_PROXIMITY_DURATION_S = 0.35;
export const DOT_PROXIMITY_RESET_DURATION_S = 0.7;
export const HOVER_FACTS_Y_PX = 20;
export const HOVER_FACTS_DURATION_S = 0.55;
export const HOVER_FACTS_STAGGER_S = 0.14;
export const HOVER_FACTS_EXTRA_DELAY_S = 0.45;
export const HOVER_FACTS_EXIT_DURATION_S = 0.18;
export const HOVER_FACTS_EXIT_STAGGER_S = 0.03;
export const HOVER_GRAPH_DRAW_DURATION_S = 0.85;
export const HOVER_GRAPH_DRAW_STAGGER_S = 0.14;
export const HOVER_EXPLORE_DURATION_S = 0.55;
export const HOVER_EXPLORE_EXTRA_DELAY_S = 0.1;
export const GRID_ENTRANCE_HR_DURATION_S = 1.4;
export const GRID_ENTRANCE_HR_EASE = "expo.out";
export const GRID_ENTRANCE_DOTS_DURATION_S = 0.7;
export const GRID_ENTRANCE_DOTS_EASE = "power2.out";
export const DETAIL_CARD_FADE_DURATION_S = 0.75;
export const DETAIL_CARD_FADE_DELAY_S = 0.05;
export const DETAIL_EXPLORE_EXTRA_DELAY_S = 0.25;
export const DETAIL_ENTRANCE_DIVIDER_STAGGER_S = 0.1;
export const DETAIL_ENTRANCE_ROW_SCATTER_STAGGER_S = 0.06;
export const DETAIL_EVENT_SLIDE_SPACE_BETWEEN_PX = 24;
export const DETAIL_EVENT_SLIDE_MOBILE_SLIDES_PER_VIEW = 1.2;
export const DETAIL_EVENT_IMAGE_SWIPER_SPEED_MS = 400;
export const DETAIL_YEAR_SWIPER_SPEED_MS = 700;
export const DETAIL_EVENT_SLIDE_HEIGHT_DURATION_S = 0.7;
export const DETAIL_EVENT_SLIDE_HEIGHT_EASE = "power2.out";
export const DETAIL_EVENT_SLIDE_CONTENT_DURATION_S = 0.45;
export const DETAIL_EVENT_SLIDE_CONTENT_STAGGER_S = 0.06;
export const DETAIL_EVENT_SLIDE_CONTENT_DELAY_S = 0.08;
export const DETAIL_EVENT_SLIDE_CONTENT_Y_PX = 18;
export const DETAIL_EVENT_SLIDE_CLOSE_HEIGHT_DURATION_S = 0.45;
export const DETAIL_EVENT_SLIDE_CLOSE_CONTENT_DURATION_S = 0.22;
export const DETAIL_EVENT_SLIDE_CLOSE_CONTENT_STAGGER_S = 0.03;
export const DETAIL_EVENT_SLIDE_CLOSE_HEIGHT_DELAY_S = 0.02;
export const HOVER_SELECT_FOLLOW_DURATION_S = 0.8;
export const HOVER_SELECT_FOLLOW_EASE = "power4.out";
export const HOVER_SELECT_FADE_DELAY_S = 0.45;
export const HOVER_SELECT_FADE_DURATION_S = 0.28;
export const HOVER_PARALLAX_MAX_TRANSLATE_PX = 20;
export const HOVER_PARALLAX_MAX_ROTATE_DEG = 5;
export const HOVER_PARALLAX_IMAGE_SCALE = 1.14;
export const HOVER_PARALLAX_DURATION_S = 3.5;
export const HOVER_PARALLAX_RESET_DURATION_S = 1.1;
export const HOVER_PARALLAX_EASE = "power2.out";
export const MOBILE_OVERVIEW_SLIDE_WIDTH_REM = 3;
/** Matches SCSS `$screensizes` `md` — desktop timeline overview starts here. */
export const TIMELINE_DESKTOP_MIN_WIDTH_PX = 1024;
export const PAGE_MARGIN_SM_REM = 1.5;
export const PAGE_MARGIN_MD_REM = 3.5;
export const MOBILE_OVERVIEW_SLIDE_EXPANDED_MAX_REM = 18.75;
export const MOBILE_OVERVIEW_MIN_HEIGHT_REM = 28;
export const MOBILE_OVERVIEW_CENTER_SPEED_MS = 300;
export const MOBILE_OVERVIEW_EXPAND_DELAY_MS = 150;
export const MOBILE_OVERVIEW_EXPAND_DURATION_MS = 650;
export const MOBILE_OVERVIEW_HOVER_REVEAL_DURATION_MS = 280;
